import { inject } from "inversify-props";
import { ConfigService } from "./config/ConfigService";
import { HttpService } from "./HttpService";
import {JwtAuthService} from "./JwtAuthService";

export interface StickyBannerData {
  id: number,
  name?: string
  impressionUrl: string,
  clickUrl: string,
  mobileImageUrl?: string,
  tabletImageUrl?: string,
  desktopImageUrl?: string,
  text?: string,
  cta?: string,
  variant?: 'primary' | 'midnight' | 'black',
  eventUrls?: {
    "17"?: string
  },
  advertiserName: string;
  priorityWeight: number;
  flightId: number;
  campaignId: number;
  advertiserId: number;
  rawClickUrl: string;
  title: string;
  height: number;
  width: number;
  contentUrl: string;
}

export enum KevelCustomEvents {
  CLOSE_AD = 17
}

interface StickyBannerDatas {
  data: { 
    [key: string]: StickyBannerData[]
  }
}

interface Placement {
  PlacementId: string
}

interface ADPostData {
  Placements: Placement[]
}

export class RMDataService {
  @inject("HttpService") httpService: HttpService;
  @inject("ConfigService") configService: ConfigService;
  @inject("JwtAuthService") jwtAuthService: JwtAuthService

  getPlacementIdByCategory(basePlacementId: string, category?: string) {
    const categoryPlacementId = category ? `-${category}` : '';
    return `${basePlacementId}${categoryPlacementId}`;
  }

  getPlacements(placementId: string) {
    return {
      Placements:[
        {
          PlacementId: placementId
        }
      ]
    }
  }

  getHeaders(): [string, string][] {
    const headers:[string, string][] = [['Content-Type', 'application/json']];

  const token = this.jwtAuthService.getToken();
  if (token) {
    headers.push(['Authorization', `Bearer ${token}`]);
  }

  return headers;
}


  async getStickyBannerData(category?: string) {
    const placementId = this.getPlacementIdByCategory('sticky-banner', category);

    const crPersonEndpoint = `${this.configService.getConfig(
      "rmUrl"
    )}/api/retailmedia/v2/Ad/MakeDecision`;
    const rmReturnedData = await this.httpService.post<ADPostData, StickyBannerDatas>(crPersonEndpoint, 
      this.getPlacements(placementId), 
      this.getHeaders()
    );
    return rmReturnedData.data[placementId] || [];
  }
}